import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {environment} from '~/environments/environment';
import {first} from 'rxjs/operators';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';
import {FormService} from '@services/form.service';
import {HttpClient} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
    registerForm: UntypedFormGroup;
    redirectUrl: string;

    loading = false;
    submitted = false;
    error = '';
    hide = true;

    disableClose = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        public authenticationService: AuthenticationService,
        private alertService: AlertService,
        public formService: FormService,
        private http: HttpClient,
        private trackingService: TrackingService,
        private cookieService: CookieService,
        public dialogRef: MatDialogRef<LoginFormComponent>) {
        if (this.authenticationService.isLogin) {
            this.router.navigate(['/app']);
        }
    }

    onNoClick(): void {
        if (this.disableClose == true) {
            return;
        }
        this.dialogRef.close(false);
    }

    ngOnInit() {
        this.redirectUrl = this.router.url;
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            username: ['', [Validators.required, Validators.email]],
            text_password: ['', [Validators.required, Validators.minLength(8)]],
        });
        this.disableClose = this.data.disableClose;
        if (this.disableClose == undefined) {
            this.disableClose = false;
        }
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.registerForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            return;
        }

        this.loading = true;

        // Le code de parrainage (cookie) est validé côté serveur.
        const parrainage = this.cookieService.get('affiliate-code') || '';

        // TODO : Move to userService
        this.http.post(`${environment.apiUrl}app/user`, {
            email: this.f.username.value,
            lastname: this.f.lastName.value,
            firstname: this.f.firstName.value,
            text_password: this.f.text_password.value,
            code_parrainage: parrainage,
        }).subscribe(
            data => {
                this.authenticationService.login(this.f.username.value, this.f.text_password.value, 'app')
                    .pipe(first())
                    .subscribe(
                        () => {
                            // this.alertService.success('Inscription reussi', true);
                            this.trackingService.register('classique');
                            this.authenticationService.loadUser().subscribe(() => {
                                this.cookieService.delete('affiliate-code', "/");
                                if (this.redirectUrl === '/app' || this.redirectUrl == null) {
                                    this.redirectUrl = '/app/search/result';
                                }
                                this.router.navigateByUrl(this.redirectUrl);
                                this.dialogRef.close();
                            });
                        },
                    );
            },
            error => {
                console.log(error);
                if (error === 'Conflict') {
                    this.alertService.error('Inscription impossible, un compte existe avec ce mail');
                } else if (error === 'Bad Request') {
                    this.alertService.error('Formulaire invalide');
                } else if (error === 'Forbidden') {
                    this.alertService.error('Le code parrain n\'existe pas');
                } else if (error == 'Un compte existe déja avec ce mail.') {
                    this.router.navigate(['/app/login'], {queryParams: {returnUrl: this.router.url, forgot: 2}});
                    this.dialogRef.close();
                } else {
                    this.alertService.error(error);
                }
                this.loading = false;
            });
    }

    signInWithGoogle(): void {
        const location = 'https://accounts.google.com/o/oauth2/v2/auth?client_id=' + environment.google_client_id +
            '&redirect_uri=https://www.lybox.fr/app/login&response_type=token' +
            '&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile' +
            '&state={"redirect":"https://www.lybox.fr' + this.redirectUrl + '","provider":"google","code":"","source":"app"}';
        window.location.href = location;
    }

    signInWithFB(): void {
        const location = 'https://www.facebook.com/v8.0/dialog/oauth?client_id=' + environment.facebook_client_id +
            '&redirect_uri=https://www.lybox.fr/app/login&response_type=token&scope=email%2Cpublic_profile' +
            '&state={"redirect":"https://www.lybox.fr' + this.redirectUrl + '","provider":"facebook","code":"","source":"app"}';
        window.location.href = location;
    }

    login() {
        this.router.navigate(['/app/login'], {queryParams: {returnUrl: this.router.url}});
        this.dialogRef.close();
    }
}
